<ng-container *transloco="let t;">
    <form [formGroup]="uploadFileForm">
        <div class="row">
            <div class="col-12">
                <div class="background-wrapper file-drop-zone" (fileDropped)="onFileDropped($event)" appDropFiles>
                    <input class="fileDrop" type="file" multiple (change)="onFileDropped($event)"
                           [accept]="acceptableFiles"/>
                    <div class="upload-icon-img ">
                        @if (processingPDF) {
                            <img src="assets/images/icons/pdf_scanning.gif" alt="Processing PDF">
                        } @else {
                            <img src="assets/images/icons/uploadIcon-files.png" alt="uploadIcon">
                        }
                    </div>
                    @if (processingPDF === false && !uploadFileForm.get('file')?.value) {
                        <span class="font-weight-500">{{ t('Drag and drop file field text (Auto-Fill Form via OpenAI PDF) - Upload a pdf file for AI processing') }}</span>
                    }
                    @if (uploadFileForm.get('file')?.value) {
                        <div class="file-name-wrapper">

                            @if (processingPDF === false) {
                                <span class="font-weight-500 file-name">{{ uploadFileForm.get('file')?.value.name }}</span>
                                <span class="ms-75 m-0 remove-file cursor-pointer text-danger" container="body"
                                      placement="auto"
                                      [autoClose]="true"
                                      triggers="hover"
                                      [ngbTooltip]="t('Delete (general) - Delete')"
                                      (click)="deleteFile()">
                                   <i class="" [size]="14" data-feather="x"></i>
                         </span>
                            } @else {
                                <div class="font-weight-500 file-name">{{ t('Drag and drop file field text, File is being analised by AI (Auto-Fill Form via OpenAI PDF) - File is being analised by AI') }}</div>
                            }
                        </div>
                    }
                    @if(formSubmitted){
                        <div class="text-center">
                            @if (uploadFileForm.get('file')?.hasError('maxSize')) {
                                <div class="invalid-feedback d-block file-validation-field">
                                    {{ uploadFileForm.get('file')?.errors?.maxSize?.message }}
                                </div>
                            }

                            @if (uploadFileForm.get('file')?.hasError('unsupportedFileType')) {
                                <div class="invalid-feedback d-block file-validation-field">
                                    {{ uploadFileForm.get('file')?.errors.unsupportedFileType }}
                                </div>
                            }

                            @if (uploadFileForm.get('file')?.hasError('required')) {
                                <div class="invalid-feedback d-block file-validation-field">
                                    {{ t('Field required (form validation) - Field name is required', {
                                    fieldName: t('File (General) - File')}) }}
                                </div>
                            }
                        </div>
                    }

                </div>
            </div>
        </div>
        <div class="row mt-1">
            <div class="col-12">
                <div class="form-group">
                    <label for="">{{ t('Document type label (general) - Document type') }}</label>
                    <ng-select
                        #SelectDocumentType
                        [items]="documentTypes | documentTypeSelectorFor: 'contract'"
                        formControlName="document_type_id"
                        bindLabel="document_type"
                        bindValue="id"
                        [loading]="isDocumentTypesLoading$ | async"
                        [loadingText]="t('Loading mask text (general) - Loading')"
                        [searchable]="true"
                        [readonly]="processingPDF"
                        [ngClass]="{ 'is-invalid error': formSubmitted && uploadFileForm.get('document_type_id').errors}">
                        <ng-template ng-loadingspinner-tmp>
                            <span class="spinner-border spinner-border-sm me-1"></span>
                        </ng-template>
                        <ng-template ng-header-tmp>
                            <input class="form-control w-100" type="text"/>
                            <span (click)="addNewDocumentType()" class="mt-50 add-docTypebtn"><i data-feather="plus"
                                                                                                 [size]="16"
                                                                                                 class="cursor-pointer"></i> {{ t("Add new document type text - (Contract control listing section - Add contract control modal) - Add new document type text") }}</span>
                        </ng-template>
                    </ng-select>
                    <div *ngIf="formSubmitted && uploadFileForm.get('document_type_id').errors" class="invalid-feedback"
                         [ngClass]="{ 'd-block': uploadFileForm.get('document_type_id').errors }">
                        <div *ngIf="uploadFileForm.get('document_type_id').errors.required">{{ t('Validation text (contractControl stepForm) - Document type is required') }}</div>
                    </div>
                </div>
            </div>
        </div>
 </form>       
    
</ng-container>